import { SOCIAL_LINKS } from "../../constants/social";

const siteUrl = "https://slickracing.com.ua";

// The organisation node itself (SportsOrganization, sameAs, logo) is declared once, statically,
// in public/index.html — so crawlers without JavaScript see it too. Components point at it by
// this @id instead of redeclaring it.
const organizationId = `${siteUrl}/#organization`;

// SEO Configuration file
const SEOConfig = {
  // Site-wide settings
  siteName: "Slick Racing Ukraine",
  defaultTitle: "Slick Racing Ukraine - Українська симрейсингова спільнота",
  titleTemplate: "%s | Slick Racing Ukraine",
  defaultDescription:
    "Slick Racing Ukraine - Сайт української симрейсингової спільноти: новини, розклад, результати, профілі пілотів від українського симрейсинг ком'юніті.",
  siteUrl,
  defaultImage: "/og-default.png", // public/ path, resolved against siteUrl in SEO.jsx
  defaultImageWidth: 1200,
  defaultImageHeight: 630,

  // Both spellings of the sport are searched for in Ukrainian. Titles and headings use "симрейсинг"; the
  // keywords meta carries both on every page, merged in by SEO.jsx.
  sportKeywords: ["симрейсинг", "сімрейсінг"],

  // Organization information
  organization: {
    id: organizationId,
    name: "Slick Racing Ukraine",
    url: siteUrl,
    // Google wants an absolute raster logo of at least 112×112.
    logo: `${siteUrl}/icon-512.png`,
    foundingDate: "2022",
    socialProfiles: SOCIAL_LINKS,
  },
};

// Reference to the sitewide organisation, for `publisher` / `organizer` / `memberOf`. Carries name
// and logo as well as the @id because Google's article and event validators read them in place.
export const publisherRef = {
  "@type": "SportsOrganization",
  "@id": organizationId,
  name: SEOConfig.organization.name,
  url: siteUrl,
  logo: {
    "@type": "ImageObject",
    url: SEOConfig.organization.logo,
    width: 512,
    height: 512,
  },
};

export default SEOConfig;
